__turbopack_context__.v({
  "approval-hand-wave": "work-sidebar-approval-hand-module__OPh14G__approval-hand-wave",
  "approvalHand": "work-sidebar-approval-hand-module__OPh14G__approvalHand",
});
